/**
 * Выбирает множественную форму русского языка в зависимости от переданного числа `amount`.
 *
 * @param amount целое число
 * @param variants варианты, например ['экскурсия', 'экскурсии', 'экскурсий']
 */
export const choosePlural = (amount: number, variants: string[]): string => {
  const _variants = variants;
  let _amount = amount;

  if (!amount) {
    _amount = 0;
  }

  const floored = Math.floor(_amount);

  if (_amount !== floored) {
    return floored === 1 ? _variants[1] : choosePlural(floored, _variants);
  }

  if (_amount % 10 === 1 && _amount % 100 !== 11) {
    return _variants[0];
  }

  if (_amount % 10 >= 2 && _amount % 10 <= 4 && (_amount % 100 < 10 || _amount % 100 >= 20)) {
    return _variants[1];
  }

  return _variants[2];
};

/**
 * Возвращает строку Число + множественная форма (1 экскурсия, 2 экскурсии, 10 экскурсий).
 *
 * @param amount целое число
 * @param variants варианты, например ['экскурсия', 'экскурсии', 'экскурсий']
 */

export const pluralize = (amount: number, variants: string[]) =>
  Number.isNaN(amount) ? '' : choosePlural(amount, variants);

export const pretextNbsp = (value: string) => {
  if (value.includes(' и ')) {
    return value.replace(' и ', ' и ');
  }

  if (value.includes(' в ')) {
    return value.replace(' в ', ' в ');
  }

  if (value.includes(' по ')) {
    return value.replace(' по ', ' по ');
  }

  if (value.includes(' на ')) {
    return value.replace(' на ', ' на ');
  }

  if (value.includes(' с ')) {
    return value.replace(' с ', ' с ');
  }

  if (value.includes(' к ')) {
    return value.replace(' к ', ' к ');
  }

  if (value.includes(' за ')) {
    return value.replaceAll(' за ', ' за ');
  }

  return value;
};
